import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { map } from 'lodash';
import FilterContent from './FilterContent';
import { FilterButton, FilterComponentWrapper, FilterTitle } from './styled';
import { DEFAULT_ALERT_SCORES } from './constants';

const FilterOption = ({ onChangeAction, optedFilterOption }) => {
  const [visible, setVisible] = useState(false);
  const [sourceIds, setSourceIds] = useState(optedFilterOption.sourceIds);

  const handleVisibleChange = () => {
    if (visible) {
      setSourceIds(optedFilterOption.sourceIds);
    }
    setVisible(!visible);
  };
  const handleSourceSelection = (selectedSourceIds) =>
    setSourceIds(selectedSourceIds);

  const handleOnClear = () => {
    const resetSourceIds = map(DEFAULT_ALERT_SCORES, 'id');
    setVisible(false);
    setSourceIds(resetSourceIds);
    onChangeAction?.(resetSourceIds);
  };

  const handleOnApply = () => {
    setVisible(false);
    onChangeAction?.(sourceIds);
  };

  return (
    <FilterComponentWrapper>
      <FilterTitle>Filter</FilterTitle>
      <Popover
        placement="bottom"
        content={
          <FilterContent
            onVisibleChange={handleVisibleChange}
            onSourceSelection={handleSourceSelection}
            selectedSourceIds={sourceIds}
            onClear={handleOnClear}
            onApply={handleOnApply}
          />
        }
        trigger="click"
        visible={visible}>
        <FilterButton onClick={handleVisibleChange}>
          <i className="fa fa-filter"></i>
        </FilterButton>
      </Popover>
    </FilterComponentWrapper>
  );
};

FilterOption.propTypes = {
  onChangeAction: PropTypes.func,
  optedFilterOption: PropTypes.object
};

export default FilterOption;
